// Components
import Modal from 'components/Modal'
import Latex from 'react-latex-next'

// Assets
import lightBulb from '../../../../../assets/images/hintIcon.png'

// Styles
import 'katex/dist/katex.min.css'

const HintModal = props => {
  // Props
  const { hintModalOpened, handleCloseHintModal, hint } = props

  return (
    <Modal
      title="Indiciu"
      isOpen={hintModalOpened}
      closeModal={handleCloseHintModal}
    >
      <div className="max-w-[450px] text-over-primary-background flex flex-row gap-[5px] mt-[35px] mb-[10px]">
        <img
          alt="hintImage"
          src={lightBulb}
          className="w-[33px] h-[33px] translate-y-[-6px]"
        />
        <Latex>{hint}</Latex>
      </div>
    </Modal>
  )
}

export default HintModal
